import {
  Component,
  OnInit
} from '@angular/core';

import Swal from 'sweetalert2';
import { MatDialog } from '@angular/material/dialog';

import { DiaryComponent } from '../diary.component';

import { ClientProcessService }
from '../../../services/clientProcess/client-process.service';

import { AddProcessComponent }
from '../../../components/diary/add-process/add-process.component';

@Component({
  selector: 'app-info-client',
  templateUrl: './info-client.component.html',
  styleUrls: ['./info-client.component.scss']
})
export class InfoClientComponent
implements OnInit {

  public processes: any[] = [];

  public loading = false;

  constructor(
    private processService:
      ClientProcessService,

    private dialog:
      MatDialog
  ) { }

  async ngOnInit() {

    await this.loadProcesses();
  }

  async loadProcesses() {

    try {

      this.loading = true;

      const response =
        await this.processService
          .getProcessesByClient(
            DiaryComponent.companyIdFocus
          );

      this.processes =
        response.data || [];

    } catch (error) {

      console.error(error);

      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No fue posible cargar los procesos'
      });

    } finally {

      this.loading = false;
    }
  }

  async openAddProcessModal() {

    const dialogRef =
      this.dialog.open(
        AddProcessComponent,
        {
          width: '90%',
          maxWidth: '1200px',
          disableClose: true,
          data: {
            clientId:
              DiaryComponent.companyIdFocus
          }
        }
      );

    dialogRef
      .afterClosed()
      .subscribe(async result => {

        if (result) {

          await this.loadProcesses();

          Swal.fire({
            icon: 'success',
            title: 'Proceso registrado',
            timer: 1500,
            showConfirmButton: false
          });
        }
      });
  }

  async editProcess(
    process: any
  ) {

    const dialogRef =
      this.dialog.open(
        AddProcessComponent,
        {
          width: '90%',
          maxWidth: '1200px',
          disableClose: true,
          data: {

            clientId:
              DiaryComponent.companyIdFocus,

            process
          }
        }
      );

    dialogRef
      .afterClosed()
      .subscribe(async result => {

        if (result) {

          await this.loadProcesses();

          Swal.fire({
            icon: 'success',
            title: 'Proceso actualizado',
            timer: 1500,
            showConfirmButton: false
          });
        }
      });
  }

  async deleteProcess(
    process: any
  ) {

    const confirm =
      await Swal.fire({

        title:
          '¿Eliminar proceso?',

        text:
          'Esta acción no se puede deshacer',

        icon:
          'warning',

        showCancelButton:
          true,

        confirmButtonText:
          'Eliminar',

        cancelButtonText:
          'Cancelar'
      });

    if (!confirm.isConfirmed) {
      return;
    }

    try {

      await this.processService
        .deleteProcess(
          process._id
        );

      await this.loadProcesses();

      Swal.fire({
        icon: 'success',
        title: 'Proceso eliminado'
      });

    } catch (error) {

      console.error(error);

      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No fue posible eliminar el proceso'
      });
    }
  }

viewProcess(
  process: any
) {

  this.dialog.open(
    AddProcessComponent,
    {
      width: '90%',
      maxWidth: '1200px',

      disableClose: false,

      data: {

        process,

        readonly: true
      }
    }
  );
}

}